import { render, staticRenderFns } from "./organizationChart.vue?vue&type=template&id=b75768a4&scoped=true"
import script from "./organizationChart.vue?vue&type=script&lang=js"
export * from "./organizationChart.vue?vue&type=script&lang=js"
import style0 from "./organizationChart.vue?vue&type=style&index=0&id=b75768a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75768a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b75768a4')) {
      api.createRecord('b75768a4', component.options)
    } else {
      api.reload('b75768a4', component.options)
    }
    module.hot.accept("./organizationChart.vue?vue&type=template&id=b75768a4&scoped=true", function () {
      api.rerender('b75768a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/organizationManage/organizationChart.vue"
export default component.exports